import type {
  StaleUserActionRequest,
  StaleUserApplyResponse,
  StaleUserListItem,
} from "shared-core/types/user";

export const GoogleIntegrationUsersStoreInjectKey = Symbol(
  "googleIntegrationUsersStore",
);
export const MicrosoftIntegrationUsersStoreInjectKey = Symbol(
  "microsoftIntegrationUsersStore",
);

export interface SuperAdminsState {
  superAdminCount: null | number;
}

export interface SuperAdminsFetcher {
  fetchSuperAdminCount(): Promise<void>;
}

export interface SuperAdminsAwareInterface
  extends SuperAdminsState, SuperAdminsFetcher {}

export interface StaleUsersState {
  staleUsers: StaleUserListItem[];
  staleUsersLastUpdated: string | null;
}

export interface StaleUsersFetcher {
  fetchStaleUsers(): Promise<void>;
  refreshStaleUsers(): Promise<void>;
  applyStaleUserActions(
    actions: StaleUserActionRequest[],
  ): Promise<StaleUserApplyResponse>;
}

export interface StaleUsersAwareInterface
  extends StaleUsersState, StaleUsersFetcher {}

export interface IntegrationUsersStore
  extends SuperAdminsAwareInterface, StaleUsersAwareInterface {}
